import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps, cx } from '../../../../../lib/styles';
import { Brand, Color } from '../../../../../lib/theme';

import panelBlockStyles from './PanelBlock_styles';
import Typography from '../../../../../components/presentational/Typography';
import Button from '../../../../../components/presentational/Button';
import Image from '../../../../../components/presentational/Image';
import Icon from '../../../../../components/presentational/Icon';
// import Input from '../../../../../components/presentational/Input';
// import { withQuery } from '../../../../../lib/stringUtils';
// import { HOME_PAGE_BUTTON } from '../../../../../lib/ga/signup';
// import { trackEvent } from '../../../../../lib/ga';

export interface PanelBlockData {
  type: 'panel_block';
  reverse?: boolean;
  brand?: Brand;
  backgroundColor?: Color;
  title: string;
  subtitle?: string;
  description?: string;
  buttonText?: string;
  buttonURL?: string;
  secondaryButtonText?: string;
  secondaryButtonURL?: string;
  joinButton?: boolean;
  topButtonText?: string;
  topButtonURL?: string;
  onClick?: () => any;
  onSecondaryClick?: () => any;
  onTopClick?: () => any;
  imageURL?: string;
  imageAlign?: 'center' | 'top' | 'bottom';
  logoHeading?: string;
  logos?: string[];
}

export interface PanelBlockProps {
  className?: string;
  blockIndex: number;
  block: PanelBlockData;
}

const PanelBlock = ({
  className,
  block: {
    backgroundColor = 'transparent',
    title,
    subtitle,
    description,
    topButtonText,
    topButtonURL,
    buttonText,
    buttonURL,
    joinButton,
    imageURL,
    logoHeading,
    logos,
    onTopClick,
    onClick,
    secondaryButtonText,
    secondaryButtonURL,
    onSecondaryClick,
  },
  styles,
}: PanelBlockProps & StylesProps<typeof panelBlockStyles>) => {
  // const [email, setEmail] = useState('');

  return (
    <div className={cx(styles.wrapper, className)}>
      <div className={styles.container}>
        {topButtonText && (
          <Button
            className={styles.topButton}
            href={topButtonURL}
            onClick={onTopClick}
            color={
              backgroundColor.startsWith('primary') ? 'secondary' : 'primary'
            }
          >
            <span>{topButtonText}</span>
            <Icon className={styles.buttonIcon} icon={'arrow_forward'} />
          </Button>
        )}

        <div className={styles.row}>
          <div className={styles.textContainer}>
            <div className={styles.textAndButton}>
              <Typography
                className={styles.text}
                color={
                  backgroundColor === 'transparent' ||
                  backgroundColor.endsWith('grey')
                    ? 'black'
                    : backgroundColor.startsWith('primary')
                    ? 'white'
                    : 'primary'
                }
              >
                {subtitle && <h3>&mdash;&nbsp;{subtitle}</h3>}
                <h1>{title}</h1>

                {description && (
                  <div dangerouslySetInnerHTML={{ __html: description }}></div>
                )}
              </Typography>

              {!joinButton && buttonText && (
                <div className={styles.buttons}>
                  <Button
                    href={buttonURL}
                    onClick={onClick}
                    color={
                      backgroundColor.startsWith('primary')
                        ? 'secondary'
                        : 'primary'
                    }
                  >
                    <span>{buttonText}</span>
                    <Icon
                      className={styles.buttonIcon}
                      icon={'arrow_forward'}
                    />
                  </Button>

                  {secondaryButtonText && (
                    <Button
                      href={secondaryButtonURL}
                      onClick={onSecondaryClick}
                      color={
                        backgroundColor.startsWith('accent')
                          ? 'secondary'
                          : 'accent'
                      }
                    >
                      <span>{secondaryButtonText}</span>
                      <Icon
                        className={styles.buttonIcon}
                        icon={'arrow_forward'}
                      />
                    </Button>
                  )}
                </div>
              )}

              {joinButton && buttonText && (
                <Button
                  href="https://startsat60.com/membership#imready"
                  type={'submit'}
                  color={'secondary'}
                >
                  <span className={styles.joinButtonText}>Join for free</span>
                  <Icon className={styles.buttonIcon} icon={'arrow_forward'} />
                </Button>
                // <form
                //   className={styles.joinWrapper}
                //   onSubmit={event => {
                //     event.preventDefault();

                //     if (!email) return false;

                //     window.open(
                //       withQuery('/authenticate', {
                //         email,
                //       }),
                //       '_self'
                //     );

                //     return false;
                //   }}
                // >
                //   <Icon color={'dark_grey'} icon={'email'} />
                //   <Input
                //     className={styles.joinInput}
                //     type={'text'}
                //     placeholder={'youremail@address.com'}
                //     onChange={setEmail}
                //     value={email}
                //   />

                //   <Button type={'submit'} color={'secondary'} onClick={onClick}>
                //     <span className={styles.joinButtonText}>{buttonText}</span>
                //     <Icon
                //       className={styles.buttonIcon}
                //       icon={'arrow_forward'}
                //     />
                //   </Button>
                // </form>
              )}
            </div>
          </div>

          {imageURL && (
            <div className={styles.imageContainer}>
              <Image
                className={styles.image}
                lazy
                resizeWidth={550}
                src={imageURL}
              />
            </div>
          )}
        </div>
      </div>

      {logos && logos.length > 0 && (
        <div className={styles.logos}>
          <div className={styles.logosContainer}>
            {logoHeading && (
              <Typography>
                <h3>{logoHeading}</h3>
              </Typography>
            )}

            <div className={styles.logoWrap}>
              {logos.map((logo, i) => (
                <Image
                  key={i}
                  lazy
                  src={logo}
                  height={100}
                  resizeHeight={100}
                  resizeFit={'min'}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default compose(styled(panelBlockStyles))(PanelBlock);
